import { render, staticRenderFns } from "./reset-password.vue?vue&type=template&id=6c99478e&scoped=true"
import script from "./reset-password.vue?vue&type=script&lang=js"
export * from "./reset-password.vue?vue&type=script&lang=js"
import style0 from "./reset-password.vue?vue&type=style&index=0&id=6c99478e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c99478e",
  null
  
)

export default component.exports